export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Announcements-Gray-0be70b596bfed465274cad04e3f3a9f9.svg";